<template>
  <modal
    :scrollY="false"
    :showCloseBtn="true"
    @leave="$emit('leave')"
  >
    <loader v-if="loading" />
    <div v-else class="flex h-full flex-col items-center justify-center">
      <div class="p-2 mb-4">
        <slot></slot>
      </div>
      <div class="flex items-center">
        <button @click="$emit('confirmed')" class="bg-tertiary border border-tertiary text-white rounded px-4 py-3 text-sm font-medium align-bottom m-2">
          {{ confirmLabel }}
        </button>
        <button @click="$emit('dismissed')" class="bg-white border border-tertiary text-tertiary rounded px-4 py-3 text-sm font-medium align-bottom m-2">
          {{ cancelLabel }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'DeletionModal',
  props: {
    confirmLabel: {
      default: 'Yes, delete it.'
    },
    cancelLabel: {
      default: 'No, go back.'
    },
    loading: {
      default: false
    }
  }
}
</script>

<style scoped>
</style>
